module.exports = __webpack_public_path__ + "static/marta-42680d9e3b0360644a2165e4ef69daa5.svg";